import Radio from 'backbone.radio';
import LoginLayout from '@/views/login_layout';

    var globalCh = Radio.channel('global');
    export default function ensure_login_layout() {
        var layout = globalCh.request('app_layout');
        if (layout) {
            if (layout.is_login_layout) {
                if (!layout.isRendered) layout.render();
                return layout;
            }
        }
        layout = new LoginLayout({ el: '#app-container'});
        layout.is_login_layout = true;
        globalCh.request('set_app_layout', layout);
        // Layout Request
        // Provide a request for parts of the app to find the app_layout,
        // e.g. controllers will want to call this up, knowing that
        // their views belong somewhere in this layout
        // NOTE in this instance this is overriding another instance of
        // the 'app_layout' request, and willy-nilly overriding behavior
        // like this is not a good pattern. Just getting things working.
        globalCh.reply('app_layout', function get_app_layout(){
            return layout;
        });
        layout.render();
        return layout;
    }

